export const fetchAudioTracksFromManifest = async (url: string) => {
    const res = await fetch(url, { method: "GET", credentials: "include" });
    const manifest = await res.text();

    const audioTracks = [];
    const lines = manifest.split("\n");

    for (const line of lines) {
        if (line.startsWith("#EXT-X-MEDIA") && line.includes("TYPE=AUDIO")) {
            const nameMatch = line.match(/NAME="([^"]+)"/);
            const langMatch = line.match(/LANGUAGE="([^"]+)"/);
            const uriMatch = line.match(/URI="([^"]+)"/);
            const groupIdMatch = line.match(/GROUP-ID="([^"]+)"/);
            const defaultMatch = line.includes("DEFAULT=YES");
            const forcedMatch = line.includes("FORCED=YES");

            let audioTrackId = 0;
            if (nameMatch?.[1]?.toLowerCase() === "comms") {
                audioTrackId = 1;
            }

            audioTracks.push({
                id: audioTrackId,
                name: nameMatch?.[1] || `Audio Track ${audioTrackId}`,
                language: langMatch?.[1] || null,
                uri: uriMatch?.[1],
                groupId: groupIdMatch?.[1],
                default: defaultMatch,
                forced: forcedMatch,
            });
        }
    }

    audioTracks.push({
        id: -1,
        name: "No Audio",
        language: null,
        default: false,
        forced: false,
    });

    return audioTracks;
};